import React, { useEffect, useState } from "react";
import { momentLocalizer, Navigate } from "react-big-calendar";
import { Icon, Popup } from "semantic-ui-react";
import { useAtom } from "jotai";
import { useMediaQuery } from "react-responsive";
import { MobileModalBody } from "./MobileModalBody";
import { MobileModalHeader } from "./MobileModalHeader";
import MobileModal from "./MobileModal";
import { Appointment_Icons } from "./Events";
import "../css/customToolbar.css";
import {
  PersonaOptions,
  sessionTiming,
} from "../constant/AppointmentConstants";
import moment from "moment";
import {
  activeButtonState,
  dateAtom,
  isOnlineAtom,
  loadingAtom,
} from "../atom/AppointmentAtoms";
import CuDropdown from "../../../common_component/component/CuDropdown";
import InputField from "../../../common_component/component/InputField";
import CuPopup from "../../../common_component/component/CuPopup";
import { FaCalendar, FaCalendarPlus } from "react-icons/fa6";
import { LuSearch } from "react-icons/lu";
import CuTooltip from "../../../common_component/component/CuTooltip";
import {
  replaceMonthAbbreviations,
  shortenDateLabel,
} from "../../../_helper/utils/utils";
import { IoCloseOutline } from "react-icons/io5";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RiMenuUnfoldLine, RiRefreshLine } from "react-icons/ri";
import {
  clinicAtom,
  doctorListAtom,
  permissionAtom,
  selectedDoctorAtom,
} from "../../../_helper/constant/constant-atom";
import { IoMdRefresh } from "react-icons/io";
import { IoMdArrowUp } from "react-icons/io";
import CuSwitcher from "../../../common_component/component/CuSwitcher";

/// Custom Toolbar

const CustomToolbar = (props) => {
  const {
    selectedSession,
    setSelectedSession,
    events,
    bookAppointment,
    isSearchOpen,
    setIsSearchOpen,
    isCustomSession,
    setIsCustomSession,
    customSessionData,
    setCustomSessionData,
    isJumpDate,
    setIsJumpDate,
    allClinic,
    setAllClinic,
    connectWebSocket,
  } = props;
  // const { events, bookAppointment } = props;
  const [searchOptions, setSearchOptions] = useState([]);
  const [doctorListOptions, setDoctorListOptions] = useState([]);
  const [doctorList] = useAtom(doctorListAtom);
  const [selectedDoctor, setSelectedDoctor] = useAtom(selectedDoctorAtom);
  const [clinic] = useAtom(clinicAtom);
  const [searchParams, setSearchParams] = useSearchParams();
  const [isVisible, setIsVisible] = useState(false);
  const [loading] = useAtom(loadingAtom);
  const [isOnline] = useAtom(isOnlineAtom);
  // const [rolePermission] = useAtom(permissionAtom);

  const navigate = useNavigate();

  const { total_appointment, completed, no_show, remaining } = events?.[
    events?.length - 1
  ] || { total_appointment: 0, completed: 0, no_show: 0, remaining: 0 };

  const [date, setDate] = useAtom(dateAtom);

  const { dayCycle, setDayCycle, userViewID, option } = props;

  const sm = !useMediaQuery({ query: "(min-width:1024px)" });

  const [isOpen, setIsOpen] = useState(false);
  // const [isJumpDate, setIsJumpDate] = useState(false);

  // const [isSearchOpen, setIsSearchOpen] = useState(false);

  const openModal = () => setIsOpen(true);

  const closeModal = () => setIsOpen(false);

  // //(dayCycle, "from custom");

  let formattedDateRange;
  let formattedDateRangeWeek;

  if (dayCycle == "week") {
    formattedDateRangeWeek = shortenDateLabel(props.label);
  }
  if (dayCycle == "agenda") {
    const [startDate, endDate] = props.label.split(" – ");

    const formattedStartDate = formatDate(startDate);

    // const formattedEndDate = formatDate(endDate);

    formattedDateRange = `${formattedStartDate}`;

    // //(formattedDateRange);

    function formatDate(dateString) {
      // //(dateString, 'kjhkjlk')
      const [month, day, year] = dateString?.split("/");
      const monthName = new Date(`${year}-${month}-${day}`)?.toLocaleString(
        "en-US",
        { month: "short" }
      );
      return `${monthName} ${parseInt(day)}, ${year?.slice(-2)}`;
    }
  }

  // //("doctor list -------", JSON.stringify(doctorList, null, 2));

  useEffect(() => {
    const mapDoctorOptions = doctorList.map((item) => ({
      key: item.id,
      value: item.id,
      text: `${item.first_name} ${item.last_name}`,
    }));
    setDoctorListOptions(mapDoctorOptions);
    if (doctorList.length > 0 && !selectedDoctor) {
      setSelectedDoctor(doctorList[0].id);
    }
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // //("setDoctorListOptions--------", doctorListOptions);
  // //("selctedDoctor", selectedDoctor);
  const panels = [
    {
      content: {
        content: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "max-content",
              fontWeight: "400",
            }}
            className="text-sm"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Total Appointments:</span>
              <span>{`${total_appointment}`}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Remaining :</span>
              <span>{`${remaining}`}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>Completed :</span>
              <span>{`${completed}`}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span>No Show :</span>
              <span>{`${no_show}`}</span>
            </div>
          </div>
        ),
      },
    },
  ];

  const [viewState, setViewState] = useState("month");
  // const [isVisible, setIsVisible] = useState(true);
  const [activeButton, setActiveButton] = useAtom(activeButtonState);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50; // the required distance between touchStart and touchEnd to be detected as a swipe
  const initialSession = searchParams.get("session") || "All";
  const initialView = searchParams.get("view");
  const onTouchStart = (e) => {
    setTouchEnd(null); // otherwise the swipe is fired even with usual touch events
    // setTouchStart(e.targetTouches[0].clientX);
  };

  // const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      goToBack();
    } else if (isRightSwipe) {
      goToNext();
    }
  };

  // useEffect(() => {
  //   setDayCycle(initialView);
  // }, [initialView]);

  const updateView = (view) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("view", view);
    setSearchParams(newParams);
    props.onView(view);
    // setDayCycle(view);
  };

  const goToDayView = () => {
    // props.onView("day");
    updateView("day");
    // setActiveButton("day");
    // setDayCycle("day");
  };

  const goWeekView = () => {
    // props.onView("week");
    updateView("week");
    // setActiveButton("week");
    // setDayCycle("week");
  };

  const goMonthView = () => {
    // setActiveButton("month");
    updateView("month");
    // setDayCycle("month");
    // props.onView("month");
  };

  const goAgendaView = () => {
    // props.onView("agenda");
    updateView("agenda");
    // setActiveButton("agenda");
    // setDayCycle("agenda");
  };

  const goToBack = () => {
    let newDate;

    switch (dayCycle) {
      case "day":
        newDate = moment(date).add(-1, "days").toDate();
        break;
      case "week":
        newDate = moment(date).add(-1, "weeks").toDate();
        break;
      case "month":
        newDate = moment(date).add(-1, "months").toDate();
        break;
      case "agenda":
        newDate = moment(date).add(-1, "days").toDate();
        break;
      default:
        newDate = date;
    }

    setDate(newDate);
  };

  const goToToday = (e = undefined) => {
    if (isJumpDate) {
      const newDate = new Date(e.target.value);
      setDate(newDate);
      setIsJumpDate(!isJumpDate);
      updateView("day");
      Navigate.DATE(date);

      // props.onNavigate(newDate)
      // props.onNavigate(Navigate.DATE, date);
    }
  };

  const goToNext = () => {
    let newDate;

    switch (dayCycle) {
      case "day":
        newDate = moment(date).add(1, "days").toDate();
        break;
      case "week":
        newDate = moment(date).add(1, "weeks").toDate();
        break;
      case "month":
        newDate = moment(date).add(1, "months").toDate();
        break;
      case "agenda":
        newDate = moment(date).add(1, "days").toDate();
        break;
      default:
        newDate = date;
    }

    setDate(newDate);
  };

  const ViewOptions = [
    { name: "Day", func: goToDayView },
    { name: "Week", func: goWeekView },
    { name: "Month", func: goMonthView },
    { name: "Agenda", func: goAgendaView },
  ];

  const handleSession = (value) => {
    // //("value-------", value);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("session", value);
    setSearchParams(newParams);

    if (value === "Custom") {
      setIsCustomSession(true);
    } else {
      setIsCustomSession(false);
      const { startTime, endTime } = sessionTiming[value];
      setSelectedSession({
        startTime: moment(date)
          ?.clone()
          ?.set({
            hour: startTime,
            minute: 0,
            second: 0,
            millisecond: 0,
          })
          ?.toDate(),
        endTime: moment(date)
          ?.clone()
          ?.set({
            hour: endTime,
            minute: value === "All" ? 59 : 0,
            second: 0,
            millisecond: 0,
          })
          ?.toDate(),
        name: value,
      });
    }
  };

  const handleCustomSessionChange = (e, label) => {
    setCustomSessionData((prev) => ({ ...prev, [label]: e.target.value }));
  };

  const handleSaveCustomSession = () => {
    const [starthours, startMin] = customSessionData?.startTime?.split(":");
    const [endhours, endMin] = customSessionData?.endTime?.split(":");
    const session = {
      startTime: moment(date)
        ?.clone()
        ?.set({
          hour: Number(starthours),
          minute: Number(startMin),
          second: 0,
          millisecond: 0,
        })
        ?.toDate(),
      endTime: moment(date)
        ?.clone()
        ?.set({
          hour: Number(endhours),
          minute: Number(endMin),
          second: 0,
          millisecond: 0,
        })
        ?.toDate(),
      name: "Custom",
    };

    setSelectedSession(session);
    setIsCustomSession(!isCustomSession);
  };

  useEffect(() => {
    if (events) {
      const options = [];
      for (let i of events) {
        if (
          i?.title?.toLowerCase() === "booked" ||
          i?.title?.toLowerCase() === "no_show" ||
          i?.title?.toLowerCase() === "complete"
        ) {
          options.push({
            key: i?.id,
            value: i?.user_details?.id,
            text: `${i?.user_details?.full_name} ${moment(i?.start).format(
              "DD MMM"
            )} (${moment(i?.start).format("hh:mm A")} - ${moment(i?.end).format(
              "hh:mm A"
            )} ${i?.title})`,
          });
        }
      }
      setSearchOptions(options);
    }
  }, [events]);

  const handleMainSearch = (val) => {
    navigate(`/new/all-patient/${val}`);
  };

  const handleSelectDoctor = (value) => {
    setSelectedDoctor(value);
  };

  // //(searchOptions, "searchOptions");
  return (
    <>
      {sm ? (
        <>
          <div
            style={{
              top: "118px",
              zIndex: "50",
              width: "83%",
              marginLeft: "33px",
            }}
            className="absolute top-118 z-50 w-98"
          >
            {isSearchOpen && (
              <div className="cu-appointment-search">
                <div className="cu-appointment-search-dropdown">
                  <CuDropdown
                    options={searchOptions}
                    onChange={handleMainSearch}
                    searchable
                  />
                </div>
                {/* <div
                  className="cu-appointment-search-close"
                  onClick={() => setIsSearchOpen(false)}
                >
                  X
                </div> */}
                <IoCloseOutline
                  size={25}
                  onClick={() => setIsSearchOpen(false)}
                />
              </div>
            )}
          </div>
          {!isSearchOpen && (
            <div className="custom-toolbar-container-mobile-not-fixed">
              <div className="cu-appointment-search-icon"></div>
            </div>
          )}

          <div className="custom-toolbar-container-mobile">
            <span className="flex items-center gap-4">
              <div>
                <LuSearch
                  onClick={() => setIsSearchOpen(true)}
                  className="h-7 w-7"
                  // alt="Search"
                />
              </div>
              <div>
                <FaCalendarPlus size={23} />
              </div>
            </span>

            {dayCycle !== "agenda" && (
              <span className="rbc-btn-group custom-rbc-btn-group2 custom-rbc-btn-group2-mobile">
                <button className="rounded" type="button" onClick={goToBack}>
                  {/* &lt; */}

                  {/* &lt; */}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15.75 19.5 8.25 12l7.5-7.5"
                    />
                  </svg>
                </button>
                {sm ? (
                  !isJumpDate ? (
                    <button
                      style={
                        dayCycle == "week"
                          ? { width: "fit-content" }
                          : {
                              width: "80px",
                              borderRadius: "3px",
                            }
                      }
                      type="button"
                      onClick={() => setIsJumpDate(true)}
                    >
                      {sm ? (
                        dayCycle == "month" ? (
                          <span className="custom-toolbar-label-month-mobile-view text-sm">
                            {props?.label.replace(/(\w{3}).*(\d{4})/, "$1 $2")}
                          </span>
                        ) : dayCycle == "day" ? (
                          <span className="text-sm">
                            {props?.label.match(/(\w+ \d+)/)[0]}
                          </span>
                        ) : dayCycle == "week" ? (
                          <span className="text-sm">
                            {formattedDateRangeWeek}
                          </span>
                        ) : dayCycle == "agenda" ? (
                          <span
                            style={{
                              fontSize: "14px",
                            }}
                          >
                            {formattedDateRange}
                          </span>
                        ) : (
                          ""
                        )
                      ) : (
                        <div></div>
                      )}
                    </button>
                  ) : (
                    <div style={{ display: "inline-block" }}>
                      <InputField
                        type={"date"}
                        style={{ width: "40px" }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            goToToday(e);
                          }
                        }}
                        onBlur={(e) => {
                          if (sm) {
                            goToToday(e);
                          }
                        }}
                        // onChange={goToToday}
                      />
                    </div>
                  )
                ) : !isJumpDate ? (
                  <button type="button" onClick={() => setIsJumpDate(true)}>
                    {/* <div id="dialog2" class="triangle_down1"></div> */}
                  </button>
                ) : (
                  <div style={{ display: "inline-block" }}>
                    <InputField
                      type={"date"}
                      style={{ width: "40px" }}
                      // onChange={goToToday}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          goToToday(e);
                        }
                      }}
                      onBlur={(e) => {
                        if (sm) {
                          goToToday(e);
                        }
                      }}
                    />
                  </div>
                )}

                <button className="rounded" type="button" onClick={goToNext}>
                  {/* &gt; */}

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-4 h-4"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m8.25 4.5 7.5 7.5-7.5 7.5"
                    />
                  </svg>
                </button>
              </span>
            )}

            <span className="flex items-center gap-4">
              <div>
                <RiRefreshLine
                  className={`cursor-pointer ${loading ? "rotate" : ""}`}
                  color="green 1.2em"
                  onClick={connectWebSocket}
                  size={23}
                />
              </div>
              <div onClick={openModal}>
                <RiMenuUnfoldLine className="h-7 w-7 text-black" />
              </div>
            </span>
          </div>
        </>
      ) : (
        <>
          <span className="block">
            {!isSearchOpen && (
              <>
                <div className="h-14 relative top-[26px] z-30 flex items-center">
                  <div className="flex justify-center items-center">
                    <CuTooltip text="Book Appointment">
                      <FaCalendarPlus
                        style={{
                          marginTop: "12.5px",
                          marginLeft: "7px",
                        }}
                        name="add to calendar"
                        className="cursor-pointer ml-2 lg:h-5 lg:w-5 large:h-6 large:w-6 xlarge:h-7 xlarge:w-7"
                        color="green 1.2em"
                        onClick={() =>
                          bookAppointment({
                            flag: true,
                            manualTime: true,
                            startTime: "",
                          })
                        }
                      />
                    </CuTooltip>
                  </div>

                  <div id="search">
                    <Popup
                      content="Search Appointment"
                      trigger={
                        <LuSearch
                          onClick={() => setIsSearchOpen(true)}
                          className="cursor-pointer ml-2 mt-2 lg:h-5 lg:w-5 large:h-7 large:w-7 xlarge:h-7 xlarge:w-7"
                          alt="Search"
                        />
                      }
                    ></Popup>
                  </div>
                </div>
              </>
            )}
            {isSearchOpen && (
              <div className="cu-appointment-search h-14 relative top-[26px] z-40">
                <FaCalendarPlus
                  style={{}}
                  className="cursor-pointer mt-4 ml-2 lg:h-5 lg:w-5 large:h-6 large:w-6 xlarge:h-7 xlarge:w-7"
                  onClick={() =>
                    bookAppointment({
                      flag: true,
                      manualTime: true,
                      startTime: "",
                    })
                  }
                />

                <div className="flex justify-center items-center gap-3 mr-4">
                  <div className="w-72">
                    <CuDropdown
                      placeholder={"Search Appointments"}
                      searchable
                      options={searchOptions}
                      onChange={handleMainSearch}
                    />
                  </div>
                  <div
                    className="cu-appointment-search-close"
                    onClick={() => setIsSearchOpen(false)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M6 18 18 6M6 6l12 12"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            )}
          </span>
          <div className="sticky-area">
            <div className="dropDown flex items-center gap-2">
              <CuDropdown
                options={PersonaOptions}
                onChange={(val) => handleSession(val)}
                value={initialSession}
              />

              {isCustomSession && (
                <div className="cu-custom-session">
                  <InputField
                    onChange={(e) => handleCustomSessionChange(e, "startTime")}
                    type={"time"}
                    value={customSessionData?.startTime}
                  />
                  <InputField
                    onChange={(e) => handleCustomSessionChange(e, "endTime")}
                    type={"time"}
                    value={customSessionData?.endTime}
                  />
                  <button
                    className="border h-11 px-4 rounded"
                    onClick={() => (
                      setIsCustomSession(false),
                      setSearchParams({ session: "All" })
                    )}
                  >
                    Cancel
                  </button>
                  <button
                    className="border h-11 px-4 rounded bg-[#C7EAC9]"
                    onClick={handleSaveCustomSession}
                  >
                    Save
                  </button>
                </div>
              )}

              {doctorList?.length > 0 && doctorListOptions?.length > 0 && (
                <CuDropdown
                  placeholder={"Select Doctor"}
                  options={doctorListOptions}
                  value={selectedDoctor}
                  onChange={handleSelectDoctor}
                />
              )}
              <div className="p-2">
                <CuSwitcher
                  toggle={allClinic === "true"}
                  setToggle={(checked) => setAllClinic(checked)}
                />
              </div>
            </div>
            <div className="custom-toolbar">
              <h3
                style={{ display: "inline" }}
                className="custom-toolbar-label text-xl lg:text-lg"
              >
                {dayCycle == "agenda" ? (
                  <span>{props?.label?.split(" ")[0]}</span>
                ) : (
                  <span className="">
                    {" "}
                    {`${clinic?.clinic_name} ${replaceMonthAbbreviations(
                      props.label
                    )}`}
                  </span>
                )}
              </h3>

              <span className="accord"></span>

              <span className=".rbc-btn-group custom-rbc-btn-group">
                <button
                  className={
                    initialView === "day" ? "active font-thin" : "font-thin"
                  }
                  type="button"
                  onClick={goToDayView}
                >
                  <span className="md:text-sm 2xl:text-lg"> Day</span>
                </button>
                <button
                  className={
                    initialView === "week" ? "active font-thin" : "font-thin"
                  }
                  type="button"
                  onClick={goWeekView}
                >
                  <span className="md:text-sm 2xl:text-lg"> Week</span>
                </button>

                <button
                  className={
                    initialView === "month" ? "active font-thin" : "font-thin"
                  }
                  type="button"
                  onClick={goMonthView}
                >
                  <span className="md:text-sm 2xl:text-lg"> Month</span>
                </button>

                <button
                  className={
                    initialView === "agenda" ? "active  font-thin" : "font-thin"
                  }
                  type="button"
                  onClick={goAgendaView}
                >
                  <span className="md:text-sm 2xl:text-lg"> Agenda</span>
                </button>
              </span>

              <span className="custom-rbc-btn-group2">
                {dayCycle !== "agenda" && (
                  <>
                    <CuTooltip text="Previous">
                      <button type="button" onClick={goToBack}>
                        {/* &lt; */}

                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="lg:w-5 lg:h-5 xl:w-6 xl:h-6 xlarge:w-7 xlarge:h-7 m-auto"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.75 19.5 8.25 12l7.5-7.5"
                          />
                        </svg>
                      </button>
                    </CuTooltip>

                    <button
                      style={
                        isJumpDate
                          ? {
                              display: "none",
                              width: "40px",
                            }
                          : { width: "40px" }
                      }
                      type="button"
                      onClick={() => setIsJumpDate(true)}
                    >
                      <FaCalendar className="lg:w-5 lg:h-5 xl:w-6 xl:h-6 xlarge:w-7 xlarge:h-7 m-auto" />
                    </button>
                    {isJumpDate ? (
                      <div
                        style={{
                          display: "inline-block",
                        }}
                        className="relative bottom-1.5"
                      >
                        <InputField
                          type={"date"}
                          style={{ width: "30px" }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              goToToday(e);
                            }
                          }}
                          onBlur={(e) => {
                            if (sm) {
                              goToToday(e);
                            }
                          }}
                        />
                      </div>
                    ) : (
                      <></>
                    )}

                    <CuTooltip text="Next">
                      <button type="button" onClick={goToNext}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="lg:w-5 lg:h-5 xl:w-6 xl:h-6 xlarge:w-7 xlarge:h-7 m-auto"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m8.25 4.5 7.5 7.5-7.5 7.5"
                          />
                        </svg>
                      </button>
                    </CuTooltip>
                  </>
                )}
              </span>
            </div>

            <span
              className={`display-appointments absolute lg:top-[130px] large:left-[10px] large:top-[133px] ${
                dayCycle == "agenda" && "bottom-0 top-0"
              }`}
            >
              <p
                style={{
                  display: "inline-block",

                  fontWeight: "400",
                  marginBottom: "0px",
                  marginRight: "15px",
                }}
                className="md:text-base xl:text-base 2xl:text-lg"
              >
                Total Appointments:{" "}
                <span className="font-bold text-base md:text-base xl:text-base 2xl:text-lg">
                  {" "}
                  {total_appointment}
                </span>
              </p>
              <p
                style={{
                  display: "inline-block",
                  fontWeight: "400",
                  marginBottom: "0px",
                  marginRight: "15px",
                }}
                className="md:text-base xl:text-base 2xl:text-lg"
              >
                Remaining:{" "}
                <span className="font-bold text-base md:text-base xl:text-base 2xl:text-lg">
                  {remaining}
                </span>
              </p>
              <p
                style={{
                  display: "inline-block",
                  fontWeight: "400",
                  marginBottom: "0px",
                  marginRight: "15px",
                }}
                className="md:text-base xl:text-base 2xl:text-lg"
              >
                Completed:{" "}
                <span className="font-bold text-base md:text-base xl:text-base 2xl:text-lg">
                  {completed}
                </span>
              </p>
              <p
                style={{
                  display: "inline-block",

                  fontWeight: "400",
                  marginBottom: "0px",
                  marginRight: "15px",
                }}
                className="md:text-base xl:text-base 2xl:text-lg"
              >
                No Show:{" "}
                <span className="font-bold text-base md:text-base xl:text-base 2xl:text-lg">
                  {no_show}
                </span>
              </p>
            </span>
          </div>
        </>
      )}

      <MobileModal
        modalClassName={"modal-container-top-right"}
        isOpen={isOpen}
        closeModal={closeModal}
      >
        <MobileModalHeader></MobileModalHeader>
        <MobileModalBody>
          {doctorList?.length > 0 && doctorListOptions?.length > 0 && (
            <div className="radio-container">
              <h2
                style={{
                  lineHeight: "45px",
                  padding: "2px",
                }}
              >
                Doctors
              </h2>

              {doctorListOptions?.map((ele, i) => {
                return (
                  <label
                    key={i}
                    htmlFor={ele.text}
                    className="doctor-radio-label"
                  >
                    {ele.text}
                    <input
                      type="radio"
                      id={ele.text}
                      name="doctor"
                      value={ele.key} // Ensure value is set correctly
                      checked={selectedDoctor === ele.key} // Ensure correct checking logic
                      onChange={() => handleSelectDoctor(ele.key)} // Pass correct value
                    />
                  </label>
                );
              })}
            </div>
          )}

          <div className="radio-container">
            <h2
              className="flex justify-between items-center"
              style={{
                lineHeight: "45px",
                padding: "2px",
              }}
            >
              Session
              <div>
                <CuPopup
                  position={"custom"}
                  customPosition={{
                    top: "25px",
                    left: "-20px",
                    transform: "translateX(-50%)",
                  }}
                  trigger={
                    <img
                      style={{
                        width: "20.25px",
                      }}
                      src={Appointment_Icons["BookAppointment"]}
                    />
                  }
                  triggerEvent="hover"
                >
                  {panels[0]?.content?.content}
                </CuPopup>
              </div>
            </h2>
            {PersonaOptions?.map((option, i) => (
              <div style={{ marginBottom: "15px" }} key={i}>
                <input
                  type="radio"
                  checked={selectedSession?.name === option?.value}
                  onChange={() => handleSession(option?.value)}
                />
                <label htmlFor={option.text.toLowerCase()}>{option.text}</label>
              </div>
            ))}
            {isCustomSession && (
              <div className="cu-custom-session">
                <InputField
                  onChange={(e) => handleCustomSessionChange(e, "startTime")}
                  type={"time"}
                  value={customSessionData?.startTime}
                  label={"Start Time"}
                />
                <InputField
                  onChange={(e) => handleCustomSessionChange(e, "endTime")}
                  type={"time"}
                  value={customSessionData?.endTime}
                  label={"End Time"}
                />
                <button onClick={handleSaveCustomSession}>Save</button>
              </div>
            )}
          </div>

          <div className="radio-container">
            <h2
              style={{
                lineHeight: "45px",
                padding: "2px",
              }}
            >
              View
            </h2>
            {ViewOptions.map((option, index) => (
              <div style={{ marginBottom: "15px" }} key={index}>
                <input
                  type="radio"
                  id={option.name.toLowerCase()}
                  name="viewOptions"
                  checked={dayCycle == option.name.toLowerCase()}
                  value={option.name.toLowerCase()}
                  onChange={() => {
                    option.func();
                  }}
                />
                <label htmlFor={option.name.toLowerCase()}>{option.name}</label>
              </div>
            ))}
          </div>
        </MobileModalBody>
      </MobileModal>

      {sm && (
        <div>
          {isVisible && (
            <span
              onClick={scrollToTop}
              className="floatable-icon-scrool-to-top"
            >
              <IoMdArrowUp className="cursor-pointer text-white" />
            </span>
          )}
        </div>
      )}

      {!sm && (
        <>
          <span
            className={`floatable-icon-book-appointment ${
              isVisible ? "right-[75px]" : "right-[25px]"
            } `}
            onClick={connectWebSocket}
          >
            <IoMdRefresh
              className={`cursor-pointer text-white ${loading ? "rotate" : ""}`}
              color="green 1.2em"
            />
          </span>

          {isVisible && (
            <span
              onClick={scrollToTop}
              className="floatable-icon-book-appointment right-[25px]"
            >
              <IoMdArrowUp className="cursor-pointer text-white" />
            </span>
          )}
        </>
      )}
    </>
  );
};

export default React.memo(CustomToolbar);
